
export const errDelMsg = {
    errDel : 'ลบข้อมูลไม่สำเร็จ'
}
export const sccDelMsg = {
    sccDel : 'ลบข้อมูลสำเร็จ'
}